import { Alert } from '@creditornot/cb-alert';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import BackButton from './BackButton';

type Props = {
  email: string;
  onBack: () => void;
};

const Heading = styled(T.Heading6)`
  margin-block-start: 24px;
  color: ${cbSemanticCssVars.textPrimary};
`;

const SuccessAlert = styled(Alert).attrs({
  variant: 'success',
})`
  margin-block-start: 24px;
`;

const EmailLoginSuccessState = ({ email, onBack }: Props) => {
  return (
    <>
      <BackButton onClick={onBack} />
      <Heading>
        <FormattedMessage id="login.withoutPassword" />
      </Heading>
      <SuccessAlert>
        <FormattedMessage
          id="login.withoutPasswordSuccess"
          values={{
            bold: chunks => <b>{chunks}</b>,
            email,
          }}
        />
      </SuccessAlert>
    </>
  );
};

export default EmailLoginSuccessState;
